import { EquipmentModal } from '../EquipmentModal/view';
import { MobileBaseTypeahead } from '../../../../shared/views/typeaheads';

export const EquipmentTypeaheadView = MobileBaseTypeahead.extend({
    model: null, // SensorEquipment
    modal_class: EquipmentModal,
    className: 'equipment_typeahead',
    i18n_key_placeholder: 'mobile_sensors_select_equipment',

    get_default_value: function () {
        const titleList = [];

        if (this.model) {
            if (this.model.get('equipment')) titleList.push(this.model.get('equipment').get('model_name'));

            if (this.model.get('location_zone')) titleList.push(this.model.get('location_zone'));

            if (this.model.get('identifier')) titleList.push(this.model.get('identifier'));
        }

        return titleList.join(' - ');
    }
});
